import React, { useState, useEffect } from 'react'
import { Box, Button, Group, TextInput, Select, LoadingOverlay, Text } from '@mantine/core'
import { createLanguage, updateLanguage } from '../../../services/languages'
import { notifications } from '@mantine/notifications'
import { IconCheck, IconX } from '@tabler/icons-react'

const FormLanguage = ({ dataDetail, onCloseModal, reloadList }) => {
    const [loading, setLoading] = useState(false)
    const [form, setForm] = useState({
        name: '',
        code: '',
        status: true,
    })

    const [errors, setErrors] = useState({
        name: '',
        code: '',
    })

    useEffect(() => {
        if (dataDetail) {
            setForm({
                name: dataDetail.name || '',
                code: dataDetail.code || '',
                status: dataDetail.status === 1,
            })
        }
    }, [dataDetail])

    const handleChange = (name, val) => {
        setForm(prev => ({ ...prev, [name]: val }))
        if (val) {
            setErrors(prev => ({ ...prev, [name]: '' }))
        }
    }

    const validate = () => {
        let isValid = true
        const newErrors = { name: '', code: '' }

        if (!form.name || form.name.trim() === '') {
            newErrors.name = 'Language Name is required'
            isValid = false
        }

        if (!form.code || form.code.trim() === '') {
            newErrors.code = 'Language Code is required'
            isValid = false
        }

        setErrors(newErrors)
        return isValid
    }

    const handleSubmit = async () => {
        if (!validate()) return

        setLoading(true)
        try {
            const payload = {
                name: form.name,
                code: form.code,
                status: form.status,
            }

            let response
            if (dataDetail) {
                response = await updateLanguage(dataDetail.id, payload)
            } else {
                response = await createLanguage(payload)
            }

            if (response.success) {
                notifications.show({
                    title: 'Success',
                    message: dataDetail ? 'Language updated successfully' : 'Language created successfully',
                    color: 'teal',
                    icon: <IconCheck />,
                })
                reloadList()
                onCloseModal()
            } else {
                notifications.show({
                    title: 'Failed',
                    message: response.message || 'Failed to update language',
                    color: 'red',
                    icon: <IconX />,
                })
            }
        } catch (error) {
            notifications.show({
                title: 'Error',
                message: error.message || 'Internal Server Error',
                color: 'red',
                icon: <IconX />,
            })
        } finally {
            setLoading(false)
        }
    }

    const statusOptions = [
        { label: 'Enabled', value: 'true' },
        { label: 'Disabled', value: 'false' },
    ]

    return (
        <Box pos="relative">
            <LoadingOverlay visible={loading} overlayProps={{ radius: "sm", blur: 2 }} />

            <Box mb="md">
                <TextInput
                    label="Language Name"
                    placeholder="Enter language name"
                    value={form.name}
                    onChange={(e) => handleChange('name', e.target.value)}
                    error={errors.name}
                    withAsterisk
                    mb="md"
                />

                <TextInput
                    label="Language Code"
                    placeholder="e.g. en-US, th-TH"
                    value={form.code}
                    onChange={(e) => handleChange('code', e.target.value)}
                    error={errors.code}
                    withAsterisk
                    mb="md"
                />

                <Select
                    label="Status"
                    data={statusOptions}
                    value={String(form.status)}
                    onChange={(val) => handleChange('status', val === 'true')}
                    mb="md"
                />
            </Box>

            <Group justify="flex-end" mt="xl">
                <Button variant="default" onClick={onCloseModal}>Cancel</Button>
                <Button onClick={handleSubmit}>{dataDetail ? 'Update' : 'Submit'}</Button>
            </Group>
        </Box>
    )
}

export default FormLanguage
